import React from 'react';
import './App.css';
import axios from 'axios';
import NavBar from './components/NavBar';
import Octagon from './components/Octagon';
import Sidekicks from './components/Sidekicks';
import ForceOfOne from './components/ForceOfOne';
import MissingInAction from './components/MissingInAction';
import LogansWar from './components/LogansWar';
import Hellbound from './components/Hellbound';




class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bgColor: '',
      fact: 'Chuck Norris\' tears cure cancer. Too bad he has never cried. Ever.'
    };
    
    this.getFact = this.getFact.bind(this);
  }


  
  getFact() {
    axios.get('https://api.chucknorris.io/jokes/random')
      .then(response => {
      this.setState({fact: response.data.value});
    }).catch(error => {
      console.log(error);
    });
  }

  render() {
    return(
      <div className="container">
        <NavBar />
        <h1><span>Chuck Norris</span> Facts</h1>
        <h3>{'"' + this.state.fact + '"'}</h3>
        <button type="button" 
          className="btn btnFact"
          onClick={this.getFact}>
          Next Chuck Fact!
        </button>
        <h2>Watch some classics!</h2>
        <div className="gridContainer">
        <Sidekicks />
        <Octagon />
        <ForceOfOne />
        <MissingInAction />
        <LogansWar />
        <Hellbound />
        </div>
      </div>
    );
  }
}

export default App